import { useContext } from 'react';
import { LayoutElementsContext } from './LayoutElementsContext';

// Custom hook to use the ElementRefContext
export const useLayoutElements = () => {
  const layoutElementsContext = useContext(LayoutElementsContext);

  return {
    appBarRef: layoutElementsContext.appBarRef,
    pageHeaderRef: layoutElementsContext.pageHeaderRef,
    homeLeftSectionRef: layoutElementsContext.homeLeftSectionRef,
    homeRightSectionRef: layoutElementsContext.homeRightSectionRef,
    taskModalRef: layoutElementsContext.taskModalRef,

    setAppBarRef: layoutElementsContext.setAppBarRef,
    setPageHeaderRef: layoutElementsContext.setPageHeaderRef,
    setHomeLeftSectionRef: layoutElementsContext.setHomeLeftSectionRef,
    setHomeRightSectionRef: layoutElementsContext.setHomeRightSectionRef,
    setTaskModalRef: layoutElementsContext.setTaskModalRef,

    isLeftModalOpen: layoutElementsContext.isLeftModalOpen,
    isRightModalOpen: layoutElementsContext.isRightModalOpen,
    isAlertOpen: layoutElementsContext.isAlertOpen,

    setIsLeftModalOpen: layoutElementsContext.setIsLeftModalOpen,
    setIsRightModalOpen: layoutElementsContext.setIsRightModalOpen,
    setIsAlertOpen: layoutElementsContext.setIsAlertOpen,
  };
};
